module.exports = __webpack_public_path__ + "static/media/logo.a65ed40a.svg";